import { consoleSandbox } from '@sentry/core';
import { DEBUG_BUILD } from './debug-build.js';

function metricShim(_name, _value, _options) {
  DEBUG_BUILD && consoleSandbox(() => {
    console.warn("You are using Sentry.metrics.* even though this bundle does not include metrics.");
  });
}
const metricsShim = {
  count: metricShim,
  gauge: metricShim,
  distribution: metricShim
};

export { metricsShim };
//# sourceMappingURL=metrics.js.map
